var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list" }, [
    _c(
      "ul",
      { staticClass: "list-items" },
      _vm._l(_vm.items, function(item) {
        return _c("li", { key: item[_vm.keyField], staticClass: "list-item" }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.selectItem(item)
                }
              }
            },
            [
              _c("div", { staticClass: "info" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "title is-size-6 has-text-weight-semibold has-text-primary"
                  },
                  [_vm._t("title", null, { item: item })],
                  2
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "description is-size-7" },
                  [_vm._t("description", null, { item: item })],
                  2
                )
              ]),
              _vm._v(" "),
              _c("next-arrow-icon")
            ],
            1
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }